// code -> { code, label }
exports.FunctionDictionary = {
  USER_VIEW:   { code: 'USER_VIEW',   label: 'Afficher les utilisateurs' },
  USER_CREATE: { code: 'USER_CREATE', label: 'Créer un utilisateur' },
  USER_UPDATE: { code: 'USER_UPDATE', label: 'Modifier un utilisateur' },
  USER_DELETE: { code: 'USER_DELETE', label: 'Supprimer un utilisateur' },

  // Clients
  CLIENT_VIEW:   { code: 'CLIENT_VIEW',   label: 'Afficher les clients' },
  CLIENT_CREATE: { code: 'CLIENT_CREATE', label: 'Créer un client' },
  CLIENT_UPDATE: { code: 'CLIENT_UPDATE', label: 'Modifier un client' },
  CLIENT_DELETE: { code: 'CLIENT_DELETE', label: 'Supprimer un client' },

  CLIENT_ACTIVATE:   { code: 'CLIENT_ACTIVATE',   label: 'Activer un client' },
  CLIENT_DEACTIVATE: { code: 'CLIENT_DEACTIVATE', label: 'Désactiver un client' },

  CLIENT_FIELD_VIEW:   { code: 'CLIENT_FIELD_VIEW',   label: 'Voir les champs extra des clients' },
  CLIENT_FIELD_CREATE: { code: 'CLIENT_FIELD_CREATE', label: 'Créer les champs extra des clients' },
  CLIENT_FIELD_UPDATE: { code: 'CLIENT_FIELD_UPDATE', label: 'Mettre-à-jour les champs extra des clients' },
  CLIENT_FIELD_DELETE: { code: 'CLIENT_FIELD_DELETE', label: 'Supprimer les champs extra des clients' },

  // Ti Kanè
  TIKANE_VIEW:   { code: 'TIKANE_VIEW',   label: 'Voir les comptes Ti Kanè' },
  TIKANE_CREATE: { code: 'TIKANE_CREATE', label: 'Ouvrir un compte Ti Kanè' },
  TIKANE_UPDATE: { code: 'TIKANE_UPDATE', label: 'Mettre à jour un compte Ti Kanè' },
  TIKANE_DELETE: { code: 'TIKANE_DELETE', label: 'Supprimer un compte Ti Kanè' },

  // Kanè Senp
  TIKANE_SENP_VIEW:   { code: 'TIKANE_SENP_VIEW',   label: 'Voir les comptes Kanè Senp' },
  TIKANE_SENP_CREATE: { code: 'TIKANE_SENP_CREATE', label: 'Ouvrir un compte Kanè Senp' },
  TIKANE_SENP_UPDATE: { code: 'TIKANE_SENP_UPDATE', label: 'Mettre à jour un compte Kanè Senp' },
  TIKANE_SENP_DELETE: { code: 'TIKANE_SENP_DELETE', label: 'Supprimer un compte Kanè Senp' },

  // Transactions
  TRANS_VIEW:   { code: 'TRANS_VIEW',   label: 'Voir les transactions' },
  TRANS_CREATE: { code: 'TRANS_CREATE', label: 'Enregistrer une transaction' },
  TRANS_UPDATE: { code: 'TRANS_UPDATE', label: 'Modifier une transaction' },
  TRANS_DELETE: { code: 'TRANS_DELETE', label: 'Annuler une transaction' },

  TRANS_DEPOSIT:  { code: 'TRANS_DEPOSIT',  label: 'Effectuer un dépôt' },
  TRANS_WITHDRAW: { code: 'TRANS_WITHDRAW', label: 'Effectuer un retrait' },
  TRANS_PAYOUT:   { code: 'TRANS_PAYOUT',   label: 'Payer la valeur finale' },

  // Dashboard
  DASHBOARD_VIEW: { code: 'DASHBOARD_VIEW', label: 'Voir le dashboard' },

  // Fichiers
  CLIENT_FILE_VIEW:   { code: 'CLIENT_FILE_VIEW',   label: 'Voir les fichiers' },
  CLIENT_FILE_UPLOAD: { code: 'CLIENT_FILE_UPLOAD', label: 'Télécharger des fichiers' },
  CLIENT_FILE_DELETE: { code: 'CLIENT_FILE_DELETE', label: 'Supprimer des fichiers' },

  // Mineurs
  CLIENT_MINOR_VIEW:   { code: 'CLIENT_MINOR_VIEW',   label: 'Voir les comptes mineurs' },
  CLIENT_MINOR_CREATE: { code: 'CLIENT_MINOR_CREATE', label: 'Créer un compte mineur' },
  CLIENT_MINOR_UPDATE: { code: 'CLIENT_MINOR_UPDATE', label: 'Modifier un compte mineur' },
  CLIENT_MINOR_DELETE: { code: 'CLIENT_MINOR_DELETE', label: 'Supprimer un compte mineur' },

  // Taux du jour
  RATE_VIEW:   { code: 'RATE_VIEW',   label: 'Voir le taux du jour (USD → HTG)' },
  RATE_UPDATE: { code: 'RATE_UPDATE', label: 'Modifier le taux du jour (USD → HTG)' },

  // Zelle
  ZELLE_VIEW:    { code: 'ZELLE_VIEW',    label: 'Voir les transactions Zelle' },
  ZELLE_CREATE:  { code: 'ZELLE_CREATE',  label: 'Créer une transaction Zelle' },
  ZELLE_UPDATE:  { code: 'ZELLE_UPDATE',  label: 'Modifier une transaction Zelle (Pending)' },
  ZELLE_DELETE:  { code: 'ZELLE_DELETE',  label: 'Supprimer une transaction Zelle' },
  ZELLE_CONFIRM: { code: 'ZELLE_CONFIRM', label: 'Confirmer / Refuser une transaction Zelle' },
  ZELLE_PAY:     { code: 'ZELLE_PAY',     label: 'Payer une transaction Zelle' },

  // MonCash
  MONCASH_VIEW:    { code: 'MONCASH_VIEW',    label: 'Voir les transactions MonCash' },
  MONCASH_CREATE:  { code: 'MONCASH_CREATE',  label: 'Créer une transaction MonCash' },
  MONCASH_UPDATE:  { code: 'MONCASH_UPDATE',  label: 'Modifier une transaction MonCash' },
  MONCASH_DELETE:  { code: 'MONCASH_DELETE',  label: 'Supprimer une transaction MonCash' },

  MONCASH_FEE_VIEW:   { code: 'MONCASH_FEE_VIEW',   label: 'Voir les frais MonCash en vigueur' },
  MONCASH_FEE_UPDATE: { code: 'MONCASH_FEE_UPDATE', label: 'Modifier les frais MonCash en vigueur' },

  // NatCash
  NATCASH_VIEW:    { code: 'NATCASH_VIEW',    label: 'Voir les transactions NatCash' },
  NATCASH_CREATE:  { code: 'NATCASH_CREATE',  label: 'Créer une transaction NatCash' },
  NATCASH_UPDATE:  { code: 'NATCASH_UPDATE',  label: 'Modifier une transaction NatCash' },
  NATCASH_DELETE:  { code: 'NATCASH_DELETE',  label: 'Supprimer une transaction NatCash' },

  NATCASH_FEE_VIEW:   { code: 'NATCASH_FEE_VIEW',   label: 'Voir les frais NatCash en vigueur' },
  NATCASH_FEE_UPDATE: { code: 'NATCASH_FEE_UPDATE', label: 'Modifier les frais NatCash en vigueur' },

  // Exchange
  EXCHANGE_VIEW:   { code: 'EXCHANGE_VIEW',   label: 'Voir les transactions Exchange' },
  EXCHANGE_CREATE: { code: 'EXCHANGE_CREATE', label: 'Créer une transaction Exchange' },
  EXCHANGE_UPDATE: { code: 'EXCHANGE_UPDATE', label: 'Modifier une transaction Exchange' },
  EXCHANGE_DELETE: { code: 'EXCHANGE_DELETE', label: 'Supprimer une transaction Exchange' },

  // Micro Crédit
  MICRO_CREDIT_VIEW:     { code: 'MICRO_CREDIT_VIEW',     label: 'Voir les comptes Micro Crédit' },
  MICRO_CREDIT_CREATE:   { code: 'MICRO_CREDIT_CREATE',   label: 'Créer un compte Micro Crédit' },
  MICRO_CREDIT_UPDATE:   { code: 'MICRO_CREDIT_UPDATE',   label: 'Modifier un compte Micro Crédit' },
  MICRO_CREDIT_DELETE:   { code: 'MICRO_CREDIT_DELETE',   label: 'Supprimer un compte Micro Crédit' },
  MICRO_CREDIT_CONFIRM:  { code: 'MICRO_CREDIT_CONFIRM',  label: 'Confirmer / Refuser un Micro Crédit' },
  MICRO_CREDIT_DISBURSE: { code: 'MICRO_CREDIT_DISBURSE', label: 'Décaisser un Micro Crédit' },
  MICRO_CREDIT_PAYMENT:  { code: 'MICRO_CREDIT_PAYMENT',  label: 'Recevoir un paiement Micro Crédit' },

  // Impression / PDF
  PRINT_DOWNLOAD:        { code: 'PRINT_DOWNLOAD',        label: 'Télécharger / imprimer un reçu PDF' },
  PRINT_SETTINGS_VIEW:   { code: 'PRINT_SETTINGS_VIEW',   label: 'Voir les paramètres d’impression' },
  PRINT_SETTINGS_UPDATE: { code: 'PRINT_SETTINGS_UPDATE', label: 'Modifier les paramètres d’impression' },

  // Caisse
  CASH_VIEW:              { code: 'CASH_VIEW',              label: 'Voir la gestion de la caisse' },
  CASH_OPEN:              { code: 'CASH_OPEN',              label: 'Demander / ouvrir une caisse' },
  CASH_OPEN_AMOUNT_EDIT:  { code: 'CASH_OPEN_AMOUNT_EDIT',  label: 'Modifier les montants d’ouverture préremplis' },
  CASH_APPORT:            { code: 'CASH_APPORT',            label: 'Demander / faire un apport de caisse' },
  CASH_WITHDRAW:          { code: 'CASH_WITHDRAW',          label: 'Demander / faire un retrait de caisse' },
  CASH_CLOSE:             { code: 'CASH_CLOSE',             label: 'Demander / clôturer une caisse' },
  CASH_HISTORY_VIEW:      { code: 'CASH_HISTORY_VIEW',      label: 'Voir l’historique des caisses' },

  CASH_MANAGEMENT_VIEW:   { code: 'CASH_MANAGEMENT_VIEW',   label: 'Accéder au module Ouverture des caisses' },

  CASH_DIRECT_OPEN:       { code: 'CASH_DIRECT_OPEN',       label: 'Ouvrir directement la caisse d’un utilisateur' },
  CASH_DIRECT_APPORT:     { code: 'CASH_DIRECT_APPORT',     label: 'Faire un apport direct sur la caisse d’un utilisateur' },
  CASH_DIRECT_WITHDRAW:   { code: 'CASH_DIRECT_WITHDRAW',   label: 'Faire un retrait direct sur la caisse d’un utilisateur' },
  CASH_DIRECT_CLOSE:      { code: 'CASH_DIRECT_CLOSE',      label: 'Clôturer directement la caisse d’un utilisateur' },

  CASH_APPROVE_OPEN:      { code: 'CASH_APPROVE_OPEN',      label: 'Approuver / refuser les demandes d’ouverture de caisse' },
  CASH_APPROVE_APPORT:    { code: 'CASH_APPROVE_APPORT',    label: 'Approuver / refuser les demandes d’apport de caisse' },
  CASH_APPROVE_WITHDRAW:  { code: 'CASH_APPROVE_WITHDRAW',  label: 'Approuver / refuser les demandes de retrait de caisse' },
  CASH_APPROVE_CLOSE:     { code: 'CASH_APPROVE_CLOSE',     label: 'Approuver / refuser les demandes de clôture de caisse' },
};
